import { getUserProfile, isSignedIn } from '../redux/actions'
import { setStoredUser, clearAuthTokens } from './authTokens'
import Api from './Api'

let latestSessionRequestId = 0

export const invalidateAdminSessionRequests = () => {
  latestSessionRequestId += 1
}

export const setAnonymousAdminSession = (dispatch, { clearStorage = false } = {}) => {
  invalidateAdminSessionRequests()

  if (clearStorage) {
    clearAuthTokens()
  } else {
    setStoredUser(null)
  }

  dispatch(isSignedIn.SetIsSignedIn(false))
}

export const confirmAdminSession = async ({
  dispatch,
  params = {},
  clearOnFailure = true,
} = {}) => {
  const requestId = ++latestSessionRequestId
  dispatch(getUserProfile.Request(params))

  try {
    const profile = await Api.getUserProfile(params)
    if (requestId !== latestSessionRequestId) {
      return null
    }

    setStoredUser(profile || null)
    dispatch(getUserProfile.Success(profile))
    return profile
  } catch (error) {
    if (requestId !== latestSessionRequestId) {
      return null
    }

    if (clearOnFailure) {
      clearAuthTokens()
    } else {
      setStoredUser(null)
    }

    dispatch(getUserProfile.Failed(error))
    return null
  }
}
